import { Controller, useForm } from 'react-hook-form'
import { MainSettingsFormProps } from './types'
import { ConfigModel } from 'shared/models'
import { Box, Button, Card, IconButton, Tab, TextField, Typography } from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'
import { getValidations } from './validation'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { NavListDnd } from './nav-list-dnd'
import { Add as AddIcon, Delete as RemoveIcon } from '@mui/icons-material'

function MainSettingsEditForm({ defaultData, onSubmit, isProcess }: MainSettingsFormProps) {
  const { control, handleSubmit } = useForm<ConfigModel>({
    defaultValues: defaultData,
    disabled: isProcess,
    resolver: yupResolver<ConfigModel>(getValidations())
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Card elevation={1}>
        <TabContext value="main">
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList>
              <Tab label="Основная информация" value="main" />
            </TabList>
          </Box>
          <TabPanel value="main">
            <Controller
              control={control}
              name="title"
              defaultValue=""
              render={({ field, fieldState }) => (
                <TextField
                  label="Заголовок (главная страница)"
                  fullWidth
                  autoComplete="off"
                  placeholder="Заголовок"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={isProcess}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="dense"
                />
              )}
            />
            <Controller
              control={control}
              name="description"
              defaultValue=""
              render={({ field, fieldState }) => (
                <TextField
                  label="Описание (главная страница)"
                  fullWidth
                  autoComplete="off"
                  placeholder="Описание"
                  multiline
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={isProcess}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="dense"
                />
              )}
            />
            <Controller
              control={control}
              name="phone"
              render={({ field, fieldState }) => (
                <TextField
                  label="Контактные номера телефона (разделенные ;)"
                  fullWidth
                  autoComplete="off"
                  placeholder="Заголовок"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={isProcess}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="dense"
                />
              )}
            />
            <Typography variant="h6" marginTop="2rem">
              Цены сертификатов
            </Typography>
            <Controller
              control={control}
              name="giftCardPrices"
              defaultValue={[]}
              render={({ field, fieldState }) => (
                <Box display="flex" gap="0 0.5rem" flexWrap="wrap">
                  {(field.value || []).map((price, index) => (
                    <Box key={index} display="flex" alignItems="center">
                      <TextField
                        autoComplete="off"
                        placeholder="Цена"
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                        type="number"
                        value={price ? String(price) : ''}
                        onChange={(ev) => {
                          const newValue = [...field.value]
                          newValue[index] = ev.target.value ? Number(ev.target.value) : (undefined as any)
                          field.onChange(newValue)
                        }}
                        onBlur={field.onBlur}
                        disabled={isProcess}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        ref={field.ref}
                        margin="dense"
                      />
                      <IconButton
                        onClick={() => field.onChange(field.value.filter((_, i) => i !== index))}
                        disabled={isProcess}
                        size='small'
                      >
                        <RemoveIcon fontSize='small' />
                      </IconButton>
                    </Box>
                  ))}
                  <Box display="flex" alignItems="center">
                    <Button
                      type="button"
                      startIcon={<AddIcon />}
                      onClick={() => field.onChange([...field.value, undefined])}
                      disabled={isProcess}
                    >
                      Добавить
                    </Button>
                  </Box>
                </Box>
              )}
            />
            <Typography variant="h6" marginTop="2rem">
              Меню сайта
            </Typography>
            <Controller
              control={control}
              name="navPages"
              render={({ field }) => <NavListDnd navList={field.value} onChange={field.onChange} />}
            />
          </TabPanel>
        </TabContext>
      </Card>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: '1rem' }}>
        <Button type="submit" variant="outlined" disabled={isProcess}>
          Сохранить
        </Button>
      </Box>
    </form>
  )
}

export { MainSettingsEditForm }
